var pt_br = {
    values: {
        to: 'até',
        Apply: 'Aplicar',
        fleet: 'Frota',
        moving: 'movendo',
        Stop: 'Parada',
        stopped: 'parado',
        Hide: 'Esconder',
        Trips: 'Viagens',
        trips: 'viagens',
        speed: 'velocidade',
        Speed: 'Velocidade',
        Back: 'Voltar',
        back: 'voltar',
        Search: 'Buscar',
        Default: 'Padrão',
        Duration: 'Duração',
        Schedules: 'Agendamentos',
        Itineraries: 'Itinerários',
        'On Going': 'Em progresso',
        'View Settings': 'Configurações de Visualização',
        'View': 'Visualizar',
        Distance: 'Distância',
        Satellite: 'Satélite',
        Transit: 'Trânsito',
        'Options': 'Opções',
        'Path Information': 'Informação do Caminho',
        'Map type': 'Tipo de Mapa',
        'Map details': 'Detalhes do Mapa',
        'until now': 'até o momento',
        'Load More': 'Carregar Mais',
        'Remove All': 'Remover Todos',
        'last trips': 'últimas viagens',
        disconnected: 'desconectado',
        'in progress': 'em progresso',
        'slow running': 'marcha lenta',
        'Total Trips': 'Total de viagens',
        'Moving First': 'Movendo Primeiro',
        'Vehicle Name': 'Nome do Veículo',
        'All Vehicles': 'Todos os Veículos',
        'View positions report': 'Ver relatório de posições',
        'View trips report': 'Ver relatório de viagens',
        'Vehicle Trips': 'Todas as viagens',
        'Most Updated': 'Mais Atualizados',
        'Less Updated': 'Menos Atualizados',
        'Driver Name': 'Nome do Motorista',
        'Stopped First': 'Parados Primeiro',
        'Remove marker': 'Remover marcador',
        'Average Velocity': 'Velocidade Média',
        'Average Speed': 'Velocidade Média',
        'Speed (Km/h)': 'Velocidade (Km/h)',
        'Timespan Information': 'Informações do Timespan',
        'Trip Information': 'Informação da Viagem',
        'Based on timespan': 'Baseado no timespan',
        'Based on timestamp': 'Baseado no timestamp',
        'Disconnected First': 'Desconectados Primeiro',
        'Search by address...': 'Busque por um endereço...',
        'View Vehicle History': 'Ver Histórico do Veículo',
        'Based on Selected trip': 'Baseado na viagem selecionada',
        'Vehicle Speed Variation': 'Variação de Velocidade do Veículo',
        'There is no trip for the selected timespan': 'Não há viagens para o período selecionado',
        'Select another timespam to view informations': 'Selecione outro período para visualizar as informações',
        'There are no results for your search.': 'Não há resultados para sua pesquisa.',
        'Redo your search to view the information.': 'Refaça sua busca para visualizar as informações.',
        'There are no trips for the selected period.': 'Não há viagens para o período selecionado.',
        'Select another period to view the information.': 'Selecione outro período para visualizar as informações.',
        'View all POIs':'Ver todos os POIs',
        'Filter by groups':'Filtrar por grupos',
        'Discard changes': 'Descatar alterações',
        'Vehicle Page': 'Página de veículos',
        'Position Report': 'Relatório de posições',
        'Trips report': 'Relatório de viagens',
        w: 's'
    }
}

module.exports = pt_br
